const WORDS = ["Healthier homes", "Stronger families", "Brighter tomorrows", "Confident choices", "One companion", "Everyday life & what’s next"];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-cyan-400/15 bg-deep py-8 sm:py-10">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((w, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className={`font-display text-4xl sm:text-6xl lg:text-7xl font-semibold tracking-tight ${i % 2 ? "outline-text" : "text-white"}`}>{w}</span>
            <svg viewBox="0 0 64 32" className="h-6 w-12 sm:h-8 sm:w-16 text-cyan-300" aria-hidden="true"><path d="M32 16c-5-7-9-11-15-11a11 11 0 0 0 0 22c6 0 10-4 15-11zm0 0c5 7 9 11 15 11a11 11 0 0 0 0-22c-6 0-10 4-15 11z" fill="none" stroke="currentColor" strokeWidth="3" /></svg>
          </span>
        ))}
      </div>
    </section>
  );
};
